(() => {
  'use strict';
  const scaler = document.querySelector('.scaler');
  const page = document.querySelector('.page');
  const fit = () => {
    if (!scaler || !page) return;
    if (window.innerWidth <= 900) { scaler.style.transform = ''; scaler.style.height = ''; return; }
    const scale = document.documentElement.clientWidth / 1680;
    scaler.style.transform = 'scale(' + scale + ')';
    scaler.style.height = (page.offsetHeight * scale) + 'px';
  };
  fit(); window.addEventListener('load', fit); window.addEventListener('resize', fit);
  new MutationObserver(fit).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['open', 'hidden'] });

  document.querySelectorAll('.site-header').forEach(header => {
    const toggle = header.querySelector('.mobile-menu-toggle');
    const navigation = header.querySelector('.main-nav');
    if (!toggle || !navigation) return;
    const closeMenu = () => {
      header.classList.remove('is-menu-open');
      toggle.setAttribute('aria-expanded', 'false');
      toggle.setAttribute('aria-label', 'Ouvrir le menu');
    };
    toggle.addEventListener('click', () => {
      const open = !header.classList.contains('is-menu-open');
      header.classList.toggle('is-menu-open', open);
      toggle.setAttribute('aria-expanded', String(open));
      toggle.setAttribute('aria-label', open ? 'Fermer le menu' : 'Ouvrir le menu');
    });
    navigation.querySelectorAll('a').forEach(link => link.addEventListener('click', closeMenu));
    window.addEventListener('resize', () => { if (window.innerWidth > 900) closeMenu(); });
  });

  document.querySelectorAll('[data-predictive-search]').forEach(form => {
    const input = form.querySelector('#siteSearch');
    const panel = form.querySelector('[data-predictive-results]');
    const content = form.querySelector('[data-predictive-content]');
    if (!input || !panel || !content) return;

    const root = window.Shopify?.routes?.root || '/';
    const currency = form.dataset.currency || window.Shopify?.currency?.active || 'EUR';
    const locale = document.documentElement.lang || 'fr-FR';
    const money = value => {
      const amount = Number.parseFloat(value);
      if (!Number.isFinite(amount)) return '';
      return new Intl.NumberFormat(locale, { style: 'currency', currency }).format(amount);
    };
    let timer;
    let controller;
    let activeIndex = -1;

    const links = () => [...content.querySelectorAll('[data-predictive-link]')];
    const close = () => {
      panel.hidden = true;
      input.setAttribute('aria-expanded', 'false');
      input.removeAttribute('aria-activedescendant');
      activeIndex = -1;
    };
    const open = () => {
      panel.hidden = false;
      input.setAttribute('aria-expanded', 'true');
    };
    const setActive = index => {
      const items = links();
      if (!items.length) return;
      activeIndex = (index + items.length) % items.length;
      items.forEach((item, itemIndex) => item.classList.toggle('is-active', itemIndex === activeIndex));
      const current = items[activeIndex];
      input.setAttribute('aria-activedescendant', current.id);
      current.scrollIntoView({ block: 'nearest' });
    };
    const showMessage = (message, className = '') => {
      content.replaceChildren();
      const status = document.createElement('p');
      status.className = 'predictive-search-status' + (className ? ' ' + className : '');
      status.textContent = message;
      content.append(status);
      open();
    };
    const render = (products, query) => {
      content.replaceChildren();
      activeIndex = -1;
      if (!products.length) {
        showMessage('Aucun produit ne correspond à « ' + query + ' ».');
        return;
      }
      const list = document.createElement('div');
      list.className = 'predictive-search-list';
      products.forEach((product, index) => {
        const link = document.createElement('a');
        link.className = 'predictive-search-item';
        link.href = product.url;
        link.id = 'voltPredictiveResult-' + index;
        link.dataset.predictiveLink = '';
        link.setAttribute('role', 'option');

        const media = document.createElement('span');
        media.className = 'predictive-search-media';
        const imageUrl = product.featured_image?.url || product.image || (typeof product.featured_image === 'string' ? product.featured_image : '');
        if (imageUrl) {
          const image = document.createElement('img');
          image.src = imageUrl;
          image.alt = '';
          image.loading = 'lazy';
          media.append(image);
        } else {
          media.textContent = 'REPUCE';
        }

        const copy = document.createElement('span');
        copy.className = 'predictive-search-copy';
        const title = document.createElement('strong');
        title.textContent = product.title;
        copy.append(title);
        const meta = document.createElement('span');
        const price = money(product.price_min ?? product.price);
        meta.textContent = [product.type, price].filter(Boolean).join(' · ');
        copy.append(meta);

        const arrow = document.createElement('b');
        arrow.setAttribute('aria-hidden', 'true');
        arrow.textContent = '›';
        link.append(media, copy, arrow);
        list.append(link);
      });
      const all = document.createElement('a');
      all.className = 'predictive-search-all';
      all.href = root + 'search?q=' + encodeURIComponent(query) + '&type=product';
      all.textContent = 'VOIR TOUS LES RÉSULTATS';
      content.append(list, all);
      open();
    };
    const search = async query => {
      controller?.abort();
      controller = new AbortController();
      showMessage('Recherche en cours…', 'is-loading');
      try {
        const url = new URL(root + 'search/suggest.json', window.location.origin);
        url.searchParams.set('q', query);
        url.searchParams.set('resources[type]', 'product');
        url.searchParams.set('resources[limit]', '8');
        url.searchParams.set('resources[options][unavailable_products]', 'last');
        url.searchParams.set('resources[options][fields]', 'title,product_type,variants.title');
        const response = await fetch(url, { signal: controller.signal, headers: { Accept: 'application/json' } });
        if (!response.ok) throw new Error('Recherche indisponible');
        const data = await response.json();
        render(data?.resources?.results?.products || [], query);
      } catch (error) {
        if (error.name !== 'AbortError') showMessage('La recherche est momentanément indisponible.');
      }
    };

    input.addEventListener('input', () => {
      window.clearTimeout(timer);
      const query = input.value.trim();
      if (!query) { controller?.abort(); close(); return; }
      timer = window.setTimeout(() => search(query), 180);
    });
    input.addEventListener('focus', () => { if (input.value.trim() && content.childElementCount) open(); });
    input.addEventListener('keydown', event => {
      const items = links();
      if (event.key === 'ArrowDown' && items.length) { event.preventDefault(); setActive(activeIndex + 1); }
      else if (event.key === 'ArrowUp' && items.length) { event.preventDefault(); setActive(activeIndex - 1); }
      else if (event.key === 'Escape') close();
      else if (event.key === 'Enter' && activeIndex >= 0 && items[activeIndex]) { event.preventDefault(); items[activeIndex].click(); }
    });
    document.addEventListener('click', event => { if (!form.contains(event.target)) close(); });
  });

  document.querySelectorAll('[data-hero-slider]').forEach(slider => {
    const slides = [...slider.querySelectorAll('[data-hero-slide]')];
    const dots = [...slider.querySelectorAll('[data-hero-dot]')];
    if (slides.length < 2) return;
    let index = 0;
    let timer;
    const show = next => {
      index = (next + slides.length) % slides.length;
      slides.forEach((slide, i) => {
        const active = i === index;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', String(!active));
      });
      dots.forEach((dot, i) => {
        const active = i === index;
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-current', String(active));
      });
    };
    const stop = () => { if (timer) window.clearInterval(timer); timer = undefined; };
    const start = () => {
      stop();
      timer = window.setInterval(() => show(index + 1), 5000);
    };
    dots.forEach((dot, i) => dot.addEventListener('click', () => { show(i); start(); }));
    document.addEventListener('visibilitychange', () => document.hidden ? stop() : start());
    show(0);
    start();
  });

  document.querySelectorAll('[data-collection-sort]').forEach(select => {
    select.addEventListener('change', () => {
      if (!select.value || !select.form) return;
      if (typeof select.form.requestSubmit === 'function') select.form.requestSubmit();
      else select.form.submit();
    });
  });

  document.querySelectorAll('[data-product-gallery]').forEach(gallery => {
    const slides = [...gallery.querySelectorAll('[data-gallery-slide]')];
    const thumbs = [...gallery.querySelectorAll('[data-gallery-thumbnail]')];
    const current = gallery.querySelector('[data-gallery-current]');
    if (!slides.length) return;
    let index = 0;
    const show = next => {
      index = (next + slides.length) % slides.length;
      slides.forEach((slide, i) => { slide.hidden = i !== index; });
      thumbs.forEach((thumb, i) => { const active = i === index; thumb.classList.toggle('is-active', active); thumb.setAttribute('aria-current', String(active)); });
      if (current) current.textContent = String(index + 1);
      thumbs[index]?.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
      fit();
    };
    gallery.addEventListener('volt:show-image', event => {
      const imageId = String(event.detail?.imageId || '');
      const next = slides.findIndex(slide => slide.dataset.imageId === imageId);
      if (next >= 0) show(next);
    });
    if (slides.length < 2) return;
    gallery.querySelector('[data-gallery-previous]')?.addEventListener('click', () => show(index - 1));
    gallery.querySelector('[data-gallery-next]')?.addEventListener('click', () => show(index + 1));
    thumbs.forEach((thumb, i) => thumb.addEventListener('click', () => show(i)));
    gallery.addEventListener('keydown', event => { if (event.key === 'ArrowLeft') show(index - 1); if (event.key === 'ArrowRight') show(index + 1); });
    let startX = 0;
    gallery.addEventListener('touchstart', event => { startX = event.changedTouches[0]?.clientX || 0; }, { passive: true });
    gallery.addEventListener('touchend', event => { const distance = (event.changedTouches[0]?.clientX || 0) - startX; if (Math.abs(distance) > 45) show(index + (distance < 0 ? 1 : -1)); }, { passive: true });
  });

  document.querySelectorAll('[data-product-detail]').forEach(product => {
    const selector = product.querySelector('[data-variant-selector]');
    const title = product.querySelector('[data-product-title]');
    const subtitle = product.querySelector('[data-product-subtitle]');
    const standaloneIntro = product.querySelector('.product-description > .volt-product-intro');
    if (standaloneIntro && subtitle) {
      subtitle.innerHTML = standaloneIntro.innerHTML;
      subtitle.hidden = false;
      standaloneIntro.hidden = true;
    }
    if (!selector) { fit(); return; }
    const price = product.querySelector('[data-product-price]');
    const compare = product.querySelector('[data-product-compare]');
    const saving = product.querySelector('[data-product-saving]');
    const addButton = product.querySelector('[data-product-add-button]');
    const descriptions = [...product.querySelectorAll('[data-variant-description]')];
    const normalize = value => (value || '').toLocaleLowerCase('fr').normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/\s+/g, ' ').trim();
    const updateVariant = () => {
      const option = selector.options[selector.selectedIndex];
      if (!option) return;
      if (title && option.dataset.productHeading) title.textContent = option.dataset.productHeading;
      if (price && option.dataset.price) price.textContent = option.dataset.price;
      const hasCompare = Boolean(option.dataset.comparePrice);
      if (compare) { compare.textContent = option.dataset.comparePrice || ''; compare.hidden = !hasCompare; }
      if (saving) { saving.textContent = option.dataset.saving || ''; saving.hidden = !hasCompare; }
      const available = option.dataset.available === 'true';
      if (addButton) { addButton.disabled = !available; addButton.textContent = available ? 'AJOUTER AU PANIER' : 'INDISPONIBLE'; }
      if (option.dataset.featuredImageId) {
        product.querySelector('[data-product-gallery]')?.dispatchEvent(new CustomEvent('volt:show-image', { detail: { imageId: option.dataset.featuredImageId } }));
      }
      if (descriptions.length) {
        const selectedTitle = normalize(option.dataset.variantTitle);
        let activePanel = null;
        descriptions.forEach(panel => {
          const values = (panel.dataset.variantDescription || '').split('|').map(normalize).filter(Boolean);
          const active = values.some(value => value === selectedTitle || selectedTitle.includes(value) || value.includes(selectedTitle));
          panel.hidden = !active;
          if (active) activePanel = panel;
        });
        if (!activePanel) {
          activePanel = descriptions[0];
          descriptions.forEach((panel, index) => { panel.hidden = index !== 0; });
        }
        const introNodes = [];
        if (activePanel) {
          for (const child of activePanel.children) {
            if (child.tagName === 'H2') break;
            introNodes.push(child);
          }
        }
        if (subtitle) {
          const copies = introNodes.map(node => { const copy = node.cloneNode(true); copy.hidden = false; return copy; });
          subtitle.replaceChildren(...copies);
          subtitle.hidden = copies.length === 0;
        }
        introNodes.forEach(node => { node.hidden = true; });
      } else if (subtitle) {
        subtitle.hidden = true;
      }
      const url = new URL(window.location.href);
      url.searchParams.set('variant', option.value);
      window.history.replaceState({}, '', url);
      fit();
    };
    selector.addEventListener('change', updateVariant);
    updateVariant();
  });

  const faqSearch = document.getElementById('faqSearch');
  if (faqSearch) {
    const clear = document.getElementById('faqSearchClear');
    const buttons = [...document.querySelectorAll('.help-category-card')];
    const groups = [...document.querySelectorAll('.help-faq-group')];
    const details = [...document.querySelectorAll('.help-faq-group details')];
    const count = document.getElementById('faqCount');
    const status = document.getElementById('helpSearchStatus');
    const none = document.getElementById('helpNoResults');
    let category = 'all';
    const normal = value => value.toLocaleLowerCase('fr').normalize('NFD').replace(/[\u0300-\u036f]/g, '').trim();
    const update = (openFirst = false) => {
      const query = normal(faqSearch.value); let total = 0; let first = null;
      groups.forEach(group => { let local = 0; group.querySelectorAll('details').forEach(item => { const match = (category === 'all' || group.dataset.category === category) && (!query || normal((item.dataset.search || '') + ' ' + item.textContent).includes(query)); item.hidden = !match; if (match) { total++; local++; first ||= item; } else item.open = false; }); group.hidden = local === 0; });
      if (clear) clear.hidden = !faqSearch.value; if (none) none.hidden = total !== 0; if (count) count.textContent = total + ' QUESTION' + (total > 1 ? 'S' : ''); if (status) status.textContent = query ? (total ? total + ' réponse' + (total > 1 ? 's' : '') + ' trouvée' + (total > 1 ? 's' : '') + '.' : 'Aucune réponse ne correspond à votre recherche.') : '';
      if (openFirst && first) { details.forEach(item => item.open = item === first); first.scrollIntoView({ behavior: 'smooth', block: 'center' }); }
    };
    buttons.forEach(button => button.addEventListener('click', () => { category = button.dataset.category || 'all'; buttons.forEach(item => item.classList.toggle('is-active', item === button)); update(); document.querySelector('.help-faq-panel')?.scrollIntoView({ behavior: 'smooth' }); }));
    faqSearch.addEventListener('input', () => update()); faqSearch.addEventListener('keydown', event => { if (event.key === 'Enter') { event.preventDefault(); update(true); } }); clear?.addEventListener('click', () => { faqSearch.value = ''; faqSearch.focus(); update(); });
    details.forEach(item => item.addEventListener('toggle', () => { if (item.open) details.forEach(other => { if (other !== item) other.open = false; }); }));
    document.querySelectorAll('[data-open-search]').forEach(button => button.addEventListener('click', () => { category = 'all'; faqSearch.value = button.dataset.openSearch || ''; update(true); })); update();
  }

  document.querySelectorAll('.contact-faq details,.shipping-faq details').forEach(item => item.addEventListener('toggle', () => { if (item.open) item.parentElement?.querySelectorAll('details').forEach(other => { if (other !== item) other.open = false; }); }));
  const message = document.getElementById('contactMessage'); const messageCount = document.getElementById('messageCount'); if (message && messageCount) { message.maxLength = 1000; const updateCount = () => messageCount.textContent = String(message.value.length); message.addEventListener('input', updateCount); updateCount(); }

  const summaryLinks = [...document.querySelectorAll('.terms-summary a')];
  if (summaryLinks.length && 'IntersectionObserver' in window) { const targets = summaryLinks.map(link => document.querySelector(link.getAttribute('href'))).filter(Boolean); const observer = new IntersectionObserver(entries => { const visible = entries.filter(entry => entry.isIntersecting).sort((a,b) => a.boundingClientRect.top - b.boundingClientRect.top)[0]; if (visible) summaryLinks.forEach(link => link.classList.toggle('is-current', link.getAttribute('href') === '#' + visible.target.id)); }, { rootMargin: '-18% 0px -66% 0px' }); targets.forEach(target => observer.observe(target)); }

  const tabs = [...document.querySelectorAll('.auth-tab')]; const panes = [...document.querySelectorAll('.auth-pane')];
  const showPane = id => { panes.forEach(pane => { const active = pane.id === id; pane.hidden = !active; pane.classList.toggle('is-active', active); }); tabs.forEach(tab => { const active = tab.getAttribute('aria-controls') === id; tab.classList.toggle('is-active', active); tab.setAttribute('aria-selected', String(active)); }); fit(); };
  tabs.forEach(tab => tab.addEventListener('click', () => showPane(tab.getAttribute('aria-controls')))); document.querySelector('[data-recover-open]')?.addEventListener('click', event => { event.preventDefault(); showPane('recoverPanel'); }); document.querySelector('[data-recover-close]')?.addEventListener('click', () => showPane('loginPanel')); if (location.hash === '#recover') showPane('recoverPanel');
  document.querySelectorAll('[data-password-toggle]').forEach(button => button.addEventListener('click', () => { const input = document.getElementById(button.dataset.passwordToggle); if (!input) return; const show = input.type === 'password'; input.type = show ? 'text' : 'password'; button.setAttribute('aria-label', show ? 'Masquer le mot de passe' : 'Afficher le mot de passe'); }));

  const liveCart = document.querySelector('[data-cart-live]');
  if (liveCart) {
    const form = liveCart.querySelector('#cartForm');
    const currency = liveCart.dataset.cartCurrency || window.Shopify?.currency?.active || 'EUR';
    const locale = document.documentElement.lang || 'fr-FR';
    const root = window.Shopify?.routes?.root || '/';
    const status = liveCart.querySelector('[data-cart-status]');
    const checkout = liveCart.querySelector('[name="checkout"]');
    const states = new WeakMap();
    let queue = Promise.resolve();
    let statusTimer;
    const money = cents => new Intl.NumberFormat(locale, { style: 'currency', currency }).format((Number(cents) || 0) / 100);
    const setStatus = (message, error = false) => {
      if (!status) return;
      window.clearTimeout(statusTimer);
      status.textContent = message;
      status.classList.toggle('is-error', error);
      if (message && !error) statusTimer = window.setTimeout(() => { status.textContent = ''; }, 1800);
    };
    const setBusy = busy => {
      liveCart.classList.toggle('is-cart-updating', busy);
      liveCart.setAttribute('aria-busy', String(busy));
      if (checkout) checkout.disabled = busy;
    };
    const updateShipping = total => {
      const threshold = Number(liveCart.dataset.freeShippingThreshold) || 0;
      const title = liveCart.querySelector('[data-cart-shipping-title]');
      const text = liveCart.querySelector('[data-cart-shipping-text]');
      const check = liveCart.querySelector('[data-cart-shipping-check]');
      if (!title || !text || !check) return;
      const offered = total >= threshold;
      title.textContent = offered ? 'VOTRE LIVRAISON À DOMICILE EST OFFERTE' : 'PLUS QUE ' + money(Math.max(0, threshold - total)) + ' POUR LA LIVRAISON À DOMICILE OFFERTE';
      text.textContent = offered ? 'Votre commande sera expédiée selon les délais configurés dans Shopify.' : 'Les options définitives seront calculées au paiement.';
      check.hidden = !offered;
    };
    const updateCartView = (cart, sourceInput, version) => {
      if (!cart.item_count) { window.location.reload(); return; }
      liveCart.dataset.cartTotal = String(cart.total_price);
      liveCart.dataset.cartSubtotal = String(cart.items_subtotal_price);
      liveCart.querySelector('[data-cart-subtotal]')?.replaceChildren(money(cart.items_subtotal_price));
      liveCart.querySelector('[data-cart-total]')?.replaceChildren(money(cart.total_price));
      const heading = liveCart.querySelector('[data-cart-heading-count]');
      if (heading) heading.textContent = '(' + cart.item_count + ' ARTICLE' + (cart.item_count > 1 ? 'S' : '') + ')';
      document.querySelectorAll('#cartCount').forEach(badge => { badge.textContent = String(cart.item_count); });
      document.querySelectorAll('.cart-btn').forEach(link => link.setAttribute('aria-label', 'Panier — ' + cart.item_count + ' article' + (cart.item_count > 1 ? 's' : '')));
      liveCart.querySelectorAll('[data-cart-item]').forEach(article => {
        const item = cart.items.find(entry => entry.key === article.dataset.cartItemKey);
        if (!item) { article.remove(); return; }
        article.dataset.cartLinePrice = String(item.final_line_price);
        article.dataset.cartUnitPrice = String(item.final_price);
        const input = article.querySelector('[data-cart-quantity]');
        if (input) {
          const hasNewerChange = input === sourceInput && states.get(input)?.version !== version;
          if (!hasNewerChange) input.value = String(item.quantity);
          input.dataset.cartConfirmedQuantity = String(item.quantity);
        }
        article.querySelector('[data-cart-line-price]')?.replaceChildren(money(item.final_line_price));
        const unit = article.querySelector('[data-cart-unit-price]');
        if (unit) unit.textContent = money(item.final_price) + ' / unité';
      });
      const summary = liveCart.querySelector('[data-cart-summary-lines]');
      if (summary) {
        summary.querySelectorAll('.discount-line').forEach(line => line.remove());
        (cart.cart_level_discount_applications || []).forEach(discount => {
          const line = document.createElement('div');
          line.className = 'discount-line';
          const title = document.createElement('dt');
          title.textContent = discount.title;
          const amount = document.createElement('dd');
          amount.textContent = '− ' + money(discount.total_allocated_amount);
          line.append(title, amount);
          summary.append(line);
        });
      }
      updateShipping(cart.total_price);
      if (sourceInput && states.get(sourceInput)?.version !== version) showOptimisticPrice(sourceInput);
      fit();
    };
    const showOptimisticPrice = input => {
      const article = input.closest('[data-cart-item]');
      if (!article) return;
      const quantity = Math.max(0, Number.parseInt(input.value, 10) || 0);
      const confirmedLine = Number(article.dataset.cartLinePrice) || 0;
      const unitPrice = Number(article.dataset.cartUnitPrice) || 0;
      const nextLine = unitPrice * quantity;
      const delta = nextLine - confirmedLine;
      article.querySelector('[data-cart-line-price]')?.replaceChildren(money(nextLine));
      liveCart.querySelector('[data-cart-subtotal]')?.replaceChildren(money((Number(liveCart.dataset.cartSubtotal) || 0) + delta));
      liveCart.querySelector('[data-cart-total]')?.replaceChildren(money((Number(liveCart.dataset.cartTotal) || 0) + delta));
      updateShipping((Number(liveCart.dataset.cartTotal) || 0) + delta);
    };
    const changeQuantity = async (input, version, quantity) => {
      const state = states.get(input);
      if (!state || state.version !== version) return;
      const key = input.dataset.cartItemKey;
      setBusy(true);
      setStatus('Mise à jour du panier…');
      try {
        const response = await fetch(root + 'cart/change.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: key, quantity })
        });
        if (!response.ok) {
          const error = await response.json().catch(() => ({}));
          throw new Error(error.description || 'Impossible de mettre à jour le panier.');
        }
        const cart = await response.json();
        updateCartView(cart, input, version);
        setStatus('Panier mis à jour.');
      } catch (error) {
        if (states.get(input)?.version === version) {
          input.value = input.dataset.cartConfirmedQuantity || '1';
          showOptimisticPrice(input);
        }
        setStatus(error.message || 'Impossible de mettre à jour le panier.', true);
      } finally {
        setBusy(false);
      }
    };
    liveCart.querySelectorAll('[data-cart-quantity]').forEach(input => {
      states.set(input, { timer: 0, version: 0 });
      input.addEventListener('input', () => {
        const state = states.get(input);
        window.clearTimeout(state.timer);
        state.version += 1;
        const version = state.version;
        input.value = String(Math.max(0, Number.parseInt(input.value, 10) || 0));
        showOptimisticPrice(input);
        const quantity = Math.max(0, Number.parseInt(input.value, 10) || 0);
        state.timer = window.setTimeout(() => {
          queue = queue.then(() => changeQuantity(input, version, quantity));
        }, 260);
      });
    });
    form?.addEventListener('submit', event => {
      if (event.submitter?.name === 'checkout') return;
      event.preventDefault();
      const input = liveCart.querySelector('[data-cart-quantity]:focus') || liveCart.querySelector('[data-cart-quantity]');
      if (input) input.dispatchEvent(new Event('input', { bubbles: true }));
    });
  }

  const promo = document.getElementById('promoCode'); document.getElementById('applyPromo')?.addEventListener('click', () => { const code = promo?.value.trim(); const feedback = document.getElementById('promoFeedback'); if (!code) { if (feedback) feedback.textContent = 'Saisissez un code promotionnel.'; return; } window.location.href = '/discount/' + encodeURIComponent(code) + '?redirect=/checkout'; });
})();
